module.exports = __webpack_public_path__ + "img/portrait_1.09b9af4e.png";